import { jsxs, jsx } from "react/jsx-runtime";
const IconPlatformAppleSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.957 8.241c-.104.081-1.948 1.12-1.948 3.43 0 2.67 2.346 3.616 2.416 3.64-.01.057-.373 1.294-1.237 2.554-.77 1.109-1.575 2.216-2.799 2.216s-1.54-.711-2.952-.711c-1.377 0-1.867.734-2.987.734s-1.9-1.026-2.799-2.286c-1.04-1.48-1.881-3.779-1.881-5.96 0-3.5 2.275-5.356 4.515-5.356 1.19 0 2.181.781 2.929.781.71 0 1.82-.828 3.173-.828.513 0 2.357.047 3.57 1.786Zm-4.212-3.267c.56-.665.955-1.586.955-2.508 0-.128-.01-.257-.034-.362-.91.034-1.994.607-2.648 1.365-.513.583-.992 1.505-.992 2.439 0 .14.024.28.035.326.057.01.15.023.244.023.818 0 1.846-.547 2.44-1.283Z" })
    ]
  }
);
export {
  IconPlatformAppleSvg
};
